module.exports = __webpack_public_path__ + "static/img/10.9446262.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/2/sp/10.png
// module id = c2t5
// module chunks = 0